import { useEffect, useState } from "react";
import { apiDownloadFile } from "../../services/FilesService";

interface Props {
    fileName: any,
    width?: any,
    height?: any
}

export const Picture = (props: Props) => {
    const [image, setImage] = useState<string>();
    const [imageLoading, setImageLoading] = useState(true);
    const [imageIsCorrupted, setImageIsCorrupted] = useState(true);

    useEffect(() => {

        apiDownloadFile(props.fileName)
            .then((response) => {
                let image = Buffer.from(response.data, 'binary').toString('base64');
                setImage(image);
                setImageLoading(false);
                setImageIsCorrupted(false);
            })
            .catch((ex: any) => {
                setImageIsCorrupted(true);
            });
    }, [props.fileName]);

    const openImageAsNewTab = (imageData: any) => {
        var image = new Image();
        image.src = imageData;
        var w = window.open("");

        if (w) {
            w.document.write(image.outerHTML);
        }
    }

    return (
        <>
            {!imageLoading && !imageIsCorrupted && <img style={{ cursor:'pointer', width: props.width || 50, height: props.height || 50 }}
                src={`data:image/jpeg;charset=utf-8;base64,${image}`}
                onClick={() => { openImageAsNewTab(`data:image/jpeg;charset=utf-8;base64,${image}`) }}
            />}
            {imageIsCorrupted && <i className="fas fa-exclamation-triangle fa-2x"></i>}
        </>
    );
};
